import { registerLocaleData } from '@angular/common';
import localeKo from '@angular/common/locales/ko';
registerLocaleData(localeKo);

import { defineLocale } from 'ngx-bootstrap/chronos';
import { koLocale } from 'ngx-bootstrap/locale';
defineLocale('ko', koLocale);

console.log('locale.ko is loaded');
